import React from 'react';
import PropTypes from 'prop-types';

import ContactForm from '../../organisms/ContactForm';

export default class Subscribe extends React.Component {
  render() {
    const { fluidButton, placeholder, header, subheader, onSubmit, centered, button } = this.props;

    return (
      <ContactForm
        onSubmit={onSubmit}
        fluidButton={fluidButton}
        button={button}
        centeredHeaders={centered}
        fields={[{ label: 'email', placeholder, type: 'input' }]}
        header={header}
        subheader={subheader}
        buttonText="Subscribe"
      />
    );
  }
}

Subscribe.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  centered: PropTypes.bool,
  fluidButton: PropTypes.bool,
  header: PropTypes.string,
  placeholder: PropTypes.string,
  subheader: PropTypes.string,
  button: PropTypes.bool,
};

Subscribe.defaultProps = {
  centered: false,
  fluidButton: false,
  header: '',
  placeholder: 'youremail@provider.com',
  subheader: '',
  button: true,
};

Subscribe.propOptions = {
  header: ['Subscribe', ''],
};
